let ci = {};
export function updateCustomerDisplayStoredBets(numTickets, totalCost) {
    if (!window.cd) {
        return;
    }
    ci['numTickets'] = numTickets;
    ci['payTotal'] = totalCost;
    window.cd.setCustomerInfo(ci);
}
export function updateCustomerDisplayPendingBet(bet) {
    if (!window.cd) {
        return;
    }
    for (const key of Object.keys(bet)) {
        ci[key] = bet[key];
    }
    window.cd.setCustomerInfo(ci);
}
export function clearCustomerDisplay() {
    if (!window.cd) {
        return;
    }
    ci = {};
    window.cd.clearCustomerInfo();
}

export function updateCustomerDisplayScannedTickets(tickets){
    if (!window.cd) {
        return;
    }
    
    window.cd.setCustomerInfo({tickets:tickets})
}